module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAkCAYAAADLsGk3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD6SURBVHgB7dnBjcIwEAXQP8Gcl2NWJCjbwZaw2wEdIDogFSAqIHRCB1ACHcQQoeRohDgBNmNOlMCgeQdr5JOtufh7aDQaTkJABWAAeRyRXxwObUV5Pqx5o4Bc7ny+/CSQ2YlXz/PHi5RAsJDJeY/SMSillFJKvR+KS55/j70P4h6PSUKuadp1rInzyJLzyAxybZvm+B/zSIBwxvgi4W5sIVqwdd3ujTH36e3WmxHhC8JwE07cjQpKKaWUUu+J0jQt+v3eHCJ/5IO7Xn3ZdZ01fIkNxI4VCHz+Xy4+YqxQDBjnEVpBMH7Kr+JY4ZnZsyz7g0DGBGftcRfrB23IVIVU07EAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/menu.png
// module id = 916
// module chunks = 0